import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogTitle, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import { OrderServicePlan } from 'src/app/models/order_service_plan.mode';
import { OrderServicePlanService } from 'src/app/services/order_service_plan.service';
import { MatProgressBar } from '@angular/material/progress-bar';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatButton } from '@angular/material/button';

@Component({
    selector: 'app-paid-confirm',
    templateUrl: './paid-confirm.component.html',
    styleUrls: ['./paid-confirm.component.scss'],
    imports: [MatProgressBar, MatDialogTitle, CdkScrollable, MatDialogContent, MatDialogActions, MatButton]
})
export class PaidConfirmComponent implements OnInit {
  loading = false;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: OrderServicePlan[],
    private orderServicePlanService: OrderServicePlanService,
    public dialogRef: MatDialogRef<PaidConfirmComponent>,


  ) { }

  ngOnInit() {
  }

  closeDialog() {
    this.dialogRef.close();
  }

  onConfirm(): void {
    this.loading = true;
    this.data.forEach((orderServicePlan: OrderServicePlan) => {
      this.orderServicePlanService.put([orderServicePlan.orderServicePlanId], orderServicePlan).subscribe(() => {
        this.loading = false;

      }, () => { 
        this.loading = false 
      });
    });
    this.closeDialog();
  }
}
